<template>
<div class="Investment-box depositbox Liabilities-card-section">
    <div class="head-text">
        <h1>Accounts</h1>
    </div>
    <div class="card-box">
        <h4>Select your option</h4>
      <v-row>
        <template>
          <v-card
            v-for="categoryList in category"
            :key="categoryList.id"
            class="boxs"
            outlined
            @click="subcategory(categoryList.childsubcategory,categoryList.subcategory_name,categoryList.id,categoryList.jump_to_router)"
          >
            <v-list-item three-line>
              <v-list-item-content>
                <div class="overline">

                    <v-row>
                      <v-col>
                        <p>{{categoryList.tot_count}}</p>
                      </v-col>
                      <v-col>
                          <v-img
                      max-height="58"
                      max-width="50"
                      :src="webIcon + categoryList.web_icon"
                          >

                          </v-img>
                        </v-col>
                    </v-row>
                </div>
                <v-list-item-title>{{categoryList.subcategory_name}}</v-list-item-title>
              </v-list-item-content>
              <v-btn @click="subcategory(categoryList.childsubcategory,categoryList.subcategory_name,categoryList.id,categoryList.jump_to_router)" text> 
                <v-img
                  max-height="30"
                  max-width="30"
                  src="https://dev-api.nimeya.ai/img/icons/forword_arrow.png"
                >
                </v-img>
              </v-btn>
            </v-list-item>
          </v-card>
        </template>
      </v-row>
    </div>
 </div>
</template>
<script>
import { POST_API, GET_API } from "../../store/actions.type";
import ApiService from '../../api/api.service';
import JwtService from ".././common/jwt.service";
   export default {
       data: () => ({
       	category:'',
       	webIcon:process.env.VUE_APP_ROOT_ICONS_URL,
      }),
        mounted (){
          Fire.$on("categoryData", () => {
          this.categoryData();
          });
          this.categoryData(); //parseCategoryData;
          },
       methods: {
          subcategory(data,subcategoryName,id,jump_to_router){
            if(id == 21){
              this.$router.push({ name: "add-trading",params: { form_id:id}})
            }else if(id == 22){
              this.$router.push({ name: "add-demat",params: { form_id:id}})
            }
            else if(id == 23){
              this.$router.push({ name: "add-e-insurance",params: { form_id:id}})
            }else{

            }

          },
          categoryData(){
          let cognito_idp = atob(localStorage.getItem('cognito_idp'));
          this.$store.dispatch(POST_API, {
                data: {
                  aws_cognito_id:cognito_idp,
                  category_id:5,
                },
                api: 'subcategory-listing',
            })
            .then((response) => {
              let categoryData = response.data;
              this.category = categoryData;
              //JwtService.setInvestmentData(JSON.stringify(this.$store.getters.getResults.data));
            });
          }
}
}
</script>